import { Injectable } from '@angular/core';

/**
 * Keeps the win-back gate (ENG-2367) on screen while it finishes. Creating
 * the subscription makes the API report trial_reset_pending: false, and the
 * next agent or user refresh drops the flag in the dashboard. Without this
 * latch the gate unmounts before it reissues the number, refreshes the user
 * and moves to Go Live.
 */
@Injectable({ providedIn: 'root' })
export class WinbackGateService {
  completing = false;
}
